<template>
    <toolbar-option v-if="!hasAspectRatio" type="stacked" :message="message">
        <template slot="secondary">
            <dropdown
                :value="unit"
                :options="unitOptions"
                native
                @input="onUnitInput"
            />
        </template>

        <template slot="primary">
            <collapse id="control-height" v-model="slider">
                <slider
                    :value="sliderIndex"
                    :values="themeObjectValues"
                    @input="onInput"
                />
            </collapse>
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option-slider';

export default {
    name: 'height',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Height',
            message: '* some options may not have any effect, depending on the element and context',
            tailwindDefinitionProp: 'height',
            defaultUnit: 'auto',
        };
    },

    computed: {
        hasAspectRatio() {
            const ASPECT_RATIO_CLASS_PREFIX = 'fu-aspect-ratio';

            return !!this.selectedElements[0].miscClasses.find(className => className.includes(ASPECT_RATIO_CLASS_PREFIX));
        },
    },

    watch: {
        changedOption({ option }) {
            if (option === 'aspect-ratio-video') this.onConflict();
        },
    },

    methods: {
        onConflict() {
            this.removeFlexClass();
            this.sliderIndex = 0;
            this.slider = false;
            this.unit = 'auto';
        },
    },
};
</script>
